import React, { Component, useEffect, useState } from 'react'
import { loadLanguage, loadLanguages, loadCountry, saveCountry, saveCity, loadCitiesWithCount, deleteCity, loadCity } from '../utils/Network';
import { useHistory } from 'react-router';


import { Link } from 'react-router-dom';
import { getDefaultName, sortByKey, sortCities } from '../utils';
import SelectStatus from '../components/select/SelectStatus';

export default function CountryContent({ id, urlParams }) {


    const history = useHistory();

    const [country, setCountry] = useState(null);
    const [cities, setCities] = useState(null);
    const [code, setCode] = useState("");
    const [names, setNames] = useState(null);
    const [city_names, setCityNames] = useState(null);

    const [languages, setLanguages] = useState(null);

    const [error, setError] = useState(null);
    const [city_error, setCityError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageloading, setPageLoading] = useState(false);

    const [city_loading, setCityLoading] = useState(false);
    const [city_done, setCityDone] = useState(false);
    const [city, setCity] = useState([]);
    const [status, setStatus] = useState([]);

    let city_id = urlParams.get('city');


    useEffect(() => {
        loadLanguages().then(languages => {

            //languages=languages.filter(x=> x.language !==16)
            setLanguages(languages);

        });
        if (id) {
            loadCountry(id).then(country => {
                setCountry(country)
                setCode(country.code)
                setNames(country.names)
            });

            setPageLoading(true)
            getCities()
        }

        if (city_id) {
            loadCity(city_id).then(city => {
                setCity(city)
                setCityNames(city.names)
            });
        }
    }, [])

    const handleDelete = (city_id, e) => {
        setLoading(city_id);
        deleteCity(city_id).then(() => {
            getCities()
        })
    }
    const handleChange = (e) => {
        switch (e.target.name) {
            case 'code':
                setCode(e.target.value)
                break;
            default: break;
        }
    }
    const handleOnChange = (e) => {
        var language_id = e.target.getAttribute("language_id")
        switch (e.target.name) {
            case "name":

                var name = null;
                if (names) {
                    name = names.find(x => x.language === parseInt(language_id));
                }

                if (name) {
                    var temp_names = [...names];
                    temp_names.find(x => x.language === parseInt(language_id)).name = e.target.value;
                    setNames(temp_names)
                }
                else {

                    var new_name = { name: e.target.value, language: parseInt(language_id) }
                    var temp_namesa = [];
                    if (names)
                        temp_namesa = [...names, new_name];
                    else temp_namesa = [new_name]
                    setNames(temp_namesa)
                }
                break;
            case "city_name":
                var city_name = null;
                if (city_names) {
                    city_name = city_names.find(x => x.language === parseInt(language_id));
                }

                if (city_name) {
                    var temp_names = [...city_names];
                    temp_names.find(x => x.language === parseInt(language_id)).name = e.target.value;
                    setCityNames(temp_names)
                }
                else {

                    var new_name = { name: e.target.value, language: parseInt(language_id) }
                    var temp_namesa = [];
                    if (city_names)
                        temp_namesa = [...city_names, new_name];
                    else temp_namesa = [new_name]
                    setCityNames(temp_namesa)
                }
                break;
            
            default:
                break;
        }



    }

    const onValue = (value, name) => {
        switch (name) {
            case 'city_status':
                var temp = city;
                temp.status = value;
                setCity(temp)
                setStatus(value)
                break;
            default: break;
        }
    }

    const saveChanges = () => {


        setError(null);
        setLoading(true);

        if (names[0].name.length < 3) {
            setError('Please Enter Name');
            setLoading(false);
            return;
        }



        if (code.length === 0) {
            setError('Please Enter Country Code');
            setLoading(false);
            return;
        }
        saveCountry({ id: id, code: code, names: names })
            .then(function (data) {
                history.push('/cms/countries?success=true');
            });



    }

    const SaveCityChanges = () => {

        setCityError(false)
        setCityDone(false)

        if (!city_names || (city_names && city_names[0].name.length < 3)) {
            setCityError('Please Enter Name');

            return;
        }

        if (cities && !city_id) {
            var check_city = cities.find(x => getDefaultName(x.names) == getDefaultName(city_names))
            if (check_city) {
                setCityError('An item with this title already exists');
                return;
            }
        }

        setCityLoading(true)


        saveCity({ id: city.id, names: city_names, status: city.status }, id).then(function (data) {
            setCityError(false)
            setCityLoading(false);
            setCityDone(true)
            getCities()
            if (city_id) {
                loadCity(city_id).then(city => {
                    setCity(city)
                })
            }
            if (!city_id) {
                setCityNames(null)
                setCity([])
            }

        });;
    }

    const getCities = () => {
        loadCitiesWithCount(id).then((data) => {
            var cities = data.results;

            cities = sortCities(cities)
            setCities(cities)
            setPageLoading(false)
            setLoading(false);
        });
    }

    return (
        <>
            <div className="content-wrapper">

                <section className="content-header">
                    <h3 class="box-title mt-5"></h3>
                    <ol className="breadcrumb">
                        <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                        <li><a href="countries"><i className="fa fa-map-marker"></i> Countries</a></li>
                        <li className="active">Details</li>
                    </ol>
                </section>


                <section className="content">
                    <div className="col-md-4">
                        <div className="box box-primary bg-ddd">
                            <div class="box-header with-border">
                                <h3 class="box-title mt-5">{id ? "Edit " : "Add "} Country {id && "/ " + id}</h3>
                            </div>
                            <div className="box-body">
                                <div className="form-group row">
                                    <div className="col-sm-12 mb-10">
                                        <input type="text" name="code" className="form-control" value={code && code} onChange={handleChange} placeholder="Code" />
                                    </div>

                                </div>
                                <div className="form-group row">

                                    {languages && languages.map((language, i) =>
                                    (
                                        <div key={i} className="col-sm-12 mb-10">
                                            <input type="text" name="name" className="form-control" language_id={language.id} value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).name : ""} onChange={handleOnChange} placeholder={language.name} />
                                        </div>
                                    )

                                    )}

                                </div>
                            </div>

                            <div className="box-footer">
                                <button type="button" onClick={saveChanges} disabled={loading} className="btn btn-info pull-right">Save Changes</button>
                                <a href="/cms/countries" type="button" className="btn btn-default float-right">Cancel</a>
                            </div>



                        </div>
                        {error && (
                            <>
                                <div className="alert alert-danger">
                                    {error}
                                </div>
                            </>
                        )}

                        {loading && (
                            <>
                                <div className="alert alert-info">
                                    please wait...
                                </div>
                            </>
                        )}
                    </div>
                    <div className="col-md-4">
                        <div className="box box-primary bg-ddd">
                            <div class="box-header with-border">
                                <h3 class="box-title mt-5">{city_id ? "Edit " : "Add "} City {country && "/ " + getDefaultName(country.names)}</h3>
                            </div>
                            <div className="box-body">

                                <div className="form-group row">

                                    {languages && languages.map((language, i) =>
                                    (
                                        <div key={i} className="col-sm-12 mb-10">
                                            <input placeholder={language.name} type="text" name="city_name" className="form-control" language_id={language.id} value={city_names && city_names.find(x => x.language === language.id) ? city_names.find(x => x.language === language.id).name : ""} onChange={handleOnChange} />
                                        </div>
                                    )

                                    )}

                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-12">
                                        <div className="form-group row">
                                            <div className="col-sm-12 mb-10">
                                                <SelectStatus callback={onValue} name={"city_status"} value={city && city.status} />
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className="box-footer">
                                <button type="button" onClick={SaveCityChanges} disabled={loading} className="btn btn-info pull-right">Save Changes</button>
                                {city_id &&
                                    <>
                                        <a href={`country/${id}`} type="button" className="btn btn-default float-right">Cancel</a>
                                    </>
                                }
                            </div>



                        </div>
                        {city_error && (
                            <>
                                <div className="alert alert-danger">
                                    {city_error}
                                </div>
                            </>
                        )}

                        {city_loading && (
                            <>
                                <div className="alert alert-info">
                                    please wait...
                                </div>
                            </>
                        )}

                        {city_done && (
                            <>
                                <div className="alert alert-success">
                                    City Saved Successfully
                                </div>
                            </>
                        )}
                    </div>
                    <div className="col-md-4">
                        <div className="box box-primary">
                            <div class="box-header with-border">
                                <h3 class="box-title mt-5">{country && getDefaultName(country.names)} Cities</h3>
                            </div>
                            <div className="box-body padding-0">
                                {pageloading && (<>
                                    <div class="overlay"><i class="fas fa-2x fa-sync-alt fa-spin"></i></div>
                                </>)}
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th className="width-50"></th>
                                            <th>Name</th>
                                            <th>Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cities && cities.map((item) => (
                                            <tr key={item.id} className={loading === item.id ? "loading" : ""}>
                                                <td>
                                                    <div className="btn-group">
                                                        <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }} className="btn btn-default btn-sm">
                                                            <i className="fa fa-trash"></i>
                                                        </button>


                                                    </div>
                                                </td>
                                                <td>
                                                    <a href={`country/${id}?city=${item.id}`}>

                                                        <p>{getDefaultName(item.names)}</p>
                                                    </a>

                                                </td>
                                                <td>{item.status ? (<i className="fa fa-check"></i>) : (<i className="fa fa-remove color-grey"></i>)}</td>

                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th></th>
                                            <th>Name</th>
                                            <th>Status</th>
                                        </tr>
                                    </tfoot>
                                </table>

                            </div>

                        </div>

                    </div>
                    <div className="clear"></div>
                </section>

            </div></>


    )

}
